/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

// var elem = document.querySelector('.Drawer__Close');
// simulateClick(elem);

document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('.click-to-enter')) return;

	// Don't follow the link
	event.preventDefault();

	// Log the clicked element in the console
	console.log(event.target);
  
    var elem = document.querySelector('.fullscreen-vid-mobile');
    elem.style.display = 'none';

}, false);

document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('.click-to-enter')) return;

	// Don't follow the link
	event.preventDefault();

	// Log the clicked element in the console
	console.log(event.target);
  
    var elem = document.querySelector('.fullscreen-vid-desktop');
    elem.style.display = 'none';

}, false);

jQuery(document).ready(function($){
  
  $('a[href="/search"]').click(function(){
    $('.Drawer__Close').trigger('click');
  });
  
  if(window.location.hash) {
    // Fragment exists
    console.log('here !!!');
  } else {
    // Fragment doesn't exist
    $('.fullscreen-vid').addClass('active');
  }
  
});

/* =============================================================================
   LOA BACKGROUND AUDIO PLAYER — Global Controller
   Uses the official YouTube IFrame Player API (YT.Player) so we get a real
   JS object with .unMute() / .setVolume() in onReady — no postMessage guessing.
   ============================================================================= */

(function() {
  'use strict';

  var STORAGE_KEY = 'loa_bg_track';

  var playerEl  = null;   // the #loa-bg-player DOM node
  var titleEl   = null;
  var toggleBtn = null;
  var closeBtn  = null;
  var iconPause = null;
  var iconPlay  = null;
  var isPaused  = false;
  var ytPlayer  = null;   // YT.Player instance
  var pendingTrack = null; // track waiting for YT API to be ready

  function isSoundPage() {
    return !!document.querySelector('.loa-sound');
  }

  function getElapsed(startedAt) {
    return Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
  }

  function setPlayingState() {
    isPaused = false;
    if (playerEl) playerEl.classList.remove('is-paused');
    if (playerEl) playerEl.classList.remove('is-waiting');
    if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Pause');
    if (iconPause) iconPause.style.display = '';
    if (iconPlay)  iconPlay.style.display  = 'none';
    if (titleEl) titleEl.removeAttribute('data-waiting');
  }

  function setPausedState() {
    isPaused = true;
    if (playerEl) playerEl.classList.add('is-paused');
    if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Play');
    if (iconPause) iconPause.style.display = 'none';
    if (iconPlay)  iconPlay.style.display  = '';
  }

  // Called once YT.Player fires onReady
  function onPlayerReady(event) {
    // Video is playing muted via autoplay — now wait for first user gesture
    // to unmute. This is the only reliable cross-browser approach.
    waitForGestureToUnmute(event.target);
  }

  // Shows a subtle "tap to hear" hint, then unmutes on first interaction
  function waitForGestureToUnmute(ytInstance) {
    if (playerEl) playerEl.classList.add('is-waiting');
    if (titleEl) titleEl.setAttribute('data-waiting', '1');

    var events = ['click', 'touchstart', 'keydown', 'scroll', 'mousemove'];
    var triggered = false;

    function onGesture() {
      if (triggered) return;
      triggered = true;

      // Remove all listeners
      events.forEach(function(ev) {
        document.removeEventListener(ev, onGesture, true);
      });

      // User has interacted — unmute now
      ytInstance.unMute();
      ytInstance.setVolume(100);
      setPlayingState();
    }

    events.forEach(function(ev) {
      document.addEventListener(ev, onGesture, { capture: true, passive: true, once: true });
    });
  }

  function createOrUpdateYT(track) {
    var elapsed = getElapsed(track.startedAt || Date.now());

    if (ytPlayer && typeof ytPlayer.loadVideoById === 'function') {
      ytPlayer.loadVideoById({ videoId: track.ytId, startSeconds: elapsed });
      // loadVideoById resets mute state — wait for gesture again
      setTimeout(function() {
        waitForGestureToUnmute(ytPlayer);
      }, 800);
    } else {
      ytPlayer = new YT.Player('loa-bg-iframe', {
        videoId: track.ytId,
        playerVars: {
          autoplay:       1,
          mute:           1,
          start:          elapsed,
          controls:       0,
          rel:            0,
          modestbranding: 1,
          playsinline:    1
        },
        events: {
          onReady:       onPlayerReady,
          onStateChange: function(e) {
            if (e.data === YT.PlayerState.ENDED) stopPlayer();
          }
        }
      });
    }
  }

  function addBodyPadding() {
    var bar = playerEl.querySelector('.loa-bg-player__bar');
    var h = bar ? bar.offsetHeight : 52;
    document.body.style.paddingBottom = h + 'px';
  }

  function removeBodyPadding() {
    document.body.style.paddingBottom = '';
  }

  function showPlayer(track) {
    if (!playerEl || !track || !track.ytId) return;
    titleEl.textContent = track.title || '—';
    playerEl.classList.add('is-active');
    addBodyPadding();

    if (typeof YT !== 'undefined' && YT.Player) {
      createOrUpdateYT(track);
    } else {
      pendingTrack = track;
    }
  }

  function stopPlayer() {
    if (!playerEl) return;
    playerEl.classList.remove('is-active');
    removeBodyPadding();

    if (ytPlayer && typeof ytPlayer.stopVideo === 'function') {
      ytPlayer.stopVideo();
    }

    // On the sound page the hero keeps playing — only clear localStorage
    // so the bar doesn't restore on next non-sound page
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  function handleToggle() {
    if (!ytPlayer) return;
    if (isPaused) {
      ytPlayer.playVideo();
      setPlayingState();
    } else {
      ytPlayer.pauseVideo();
      setPausedState();
    }
  }

  // YT API calls this globally when the script is ready
  var _existingAPIReady = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function() {
    if (typeof _existingAPIReady === 'function') _existingAPIReady();
    if (pendingTrack) {
      createOrUpdateYT(pendingTrack);
      pendingTrack = null;
    }
  };

  function init() {
    playerEl  = document.getElementById('loa-bg-player');
    if (!playerEl) return;

    // The #loa-bg-iframe div is the YT.Player mount point — must be a div, not an iframe
    titleEl   = document.getElementById('loa-bg-title');
    toggleBtn = document.getElementById('loa-bg-toggle');
    closeBtn  = document.getElementById('loa-bg-close');
    iconPause = toggleBtn ? toggleBtn.querySelector('.icon-pause') : null;
    iconPlay  = toggleBtn ? toggleBtn.querySelector('.icon-play')  : null;

    if (toggleBtn) toggleBtn.addEventListener('click', handleToggle);
    if (closeBtn)  closeBtn.addEventListener('click', stopPlayer);

    // Listen for event fired from the sound page bg button — show bar even on sound page
    document.addEventListener('loa:bg-play', function(e) {
      if (!e.detail) return;

      if (isSoundPage()) {
        // On the sound page the hero is already playing — just show the bar UI
        // without loading the hidden iframe (which would cause double audio)
        if (!playerEl) return;
        titleEl.textContent = e.detail.title || '—';
        playerEl.classList.add('is-active');
        addBodyPadding();
        setPlayingState();
        return;
      }

      showPlayer(e.detail);
    });

    // Load the YT IFrame API script on every page (idempotent)
    if (!document.getElementById('loa-yt-api')) {
      var tag = document.createElement('script');
      tag.id  = 'loa-yt-api';
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }

    // Auto-restore from localStorage after navigation
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var track = JSON.parse(stored);
        if (track && track.ytId) {
          if (isSoundPage()) {
            // On the sound page: show bar UI only — no hidden iframe needed,
            // the hero is the audio source
            titleEl.textContent = track.title || '—';
            playerEl.classList.add('is-active');
            addBodyPadding();
            setPlayingState();
          } else {
            showPlayer(track);
          }
        }
      }
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();